import { useState, useEffect, useCallback } from "react";
import { getFirestore } from "../../config/firebase";

export default function useInscriptos(firebaseDocId) {
  const [inscriptos, setInscriptos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchInscriptos = useCallback(async () => {
    if (!firebaseDocId) return;

    setLoading(true);
    setError(null);
    try {
      const db = getFirestore();
      const doc = await db.collection("eventos").doc(firebaseDocId).get();

      if (!doc.exists) {
        setInscriptos([]);
        return;
      }

      const data = doc.data();
      const lista = (data.inscriptos || []).slice().sort((a, b) => {
        const da = a.fechaISO ? new Date(a.fechaISO) : 0;
        const db_ = b.fechaISO ? new Date(b.fechaISO) : 0;
        return db_ - da;
      });
      setInscriptos(lista);
    } catch (err) {
      console.error("Error al cargar inscriptos:", err);
      setError("No se pudieron cargar los inscriptos. Verificá las reglas de Firestore.");
    } finally {
      setLoading(false);
    }
  }, [firebaseDocId]);

  useEffect(() => {
    fetchInscriptos();
  }, [fetchInscriptos]);

  return { inscriptos, loading, error, refetch: fetchInscriptos };
}
